module.exports = __webpack_public_path__ + "static/Ghoul-cfc37f75ddd948510c0dd4c7cdf379d4.jpg";